export const navigation = {
  categories: [
    {
      id: "women",
      name: "Women",
      featured: [
        {
          name: "New Arrivals",
          href: "/",
          imageSrc:
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/mega-menu-category-01.jpg",
          imageAlt:
            "Models sitting back to back, wearing Basic Tee in black and bone.",
        },
        {
          name: "Basic Tees",
          href: "/",
          imageSrc:
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/mega-menu-category-02.jpg",
          imageAlt:
            "Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.",
        },
      ],
      sections: [
        {
          id: "clothing",
          name: "Clothing",
          items: [
            { name: "Tops", id: "top", href: `{women/clothing/tops}` },
            { name: "Dresses", id: "women_dress", href: "#" },
            { name: "Women Jeans", id: "women_jeans" },
            { name: "Lengha Choli", id: "lengha_choli" },
            { name: "Sweaters", id: "sweater" },
            { name: "T-Shirts", id: "t-shirts" },
            { name: "Jackets", id: "jacket" },
            { name: "Gouns", id: "gouns" },
            { name: "Sarees", id: "saree" },
            { name: "Kurtas", id: "kurtas" },
          ],
        },
        // {
        //   id: "accessories",
        //   name: "Accessories",
        //   items: [
        //     { name: "Watches", id: "watch" },
        //     { name: "Wallets", id: "wallet" },
        //     { name: "Bags", id: "bag" },
        //     { name: "Sunglasses", id: "sunglasse" },
        //     { name: "Hats", id: "hat" },
        //     { name: "Belts", id: "belt" },
        //   ],
        // },
        // {
        //   id: "brands",
        //   name: "Brands",
        //   items: [
        //     { name: "Full Nelson", id: "#" },
        //     { name: "My Way", id: "#" },
        //     { name: "Re-Arranged", id: "#" },
        //     { name: "Counterfeit", id: "#" },
        //     { name: "Significant Other", id: "#" },
        //   ],
        // },
      ],
    },
    {
      id: "men",
      name: "Men",
      featured: [
        {
          name: "New Arrivals",
          id: "#",
          imageSrc:
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-04-detail-product-shot-01.jpg",
          imageAlt:
            "Drawstring top with elastic loop closure and textured interior padding.",
        },
        {
          name: "Artwork Tees",
          id: "#",
          imageSrc:
            "https://tailwindcss.com/plus-assets/img/ecommerce-images/category-page-02-image-card-06.jpg",
          imageAlt:
            "Three shirts in gray, white, and blue arranged on table with same line drawing of hands and shapes overlapping on front of shirt.",
        },
      ],
      sections: [
        {
          id: "clothing",
          name: "Clothing",
          items: [
            { name: "Mens Kurtas", id: "mens_kurta" },
            { name: "Shirt", id: "shirt" },
            { name: "Men Jeans", id: "men_jeans" },
            { name: "Sweaters", id: "sweaters" },
            { name: "T-Shirts", id: "t-shirts" },
            { name: "Jackets", id: "jackets" },
            { name: "Activewear", id: "activewear" },
          ],
        },
        // {
        //   id: "accessories",
        //   name: "Accessories",
        //   items: [
        //     { name: "Watches", id: "#" },
        //     { name: "Wallets", id: "#" },
        //     { name: "Bags", id: "#" },
        //     { name: "Sunglasses", id: "#" },
        //     { name: "Hats", id: "#" },
        //     { name: "Belts", id: "#" },
        //   ],
        // },
        // {
        //   id: "brands",
        //   name: "Brands",
        //   items: [
        //     { name: "Re-Arranged", id: "#" },
        //     { name: "Counterfeit", id: "#" },
        //     { name: "Full Nelson", id: "#" },
        //     { name: "My Way", id: "#" },
        //   ],
        // },
      ],
    },
    {
      id: "kids",
      name: "Kids",
      featured: [
        {
          name: "New Arrivals",
          href: "/",
          imageSrc:
            "https://rukminim2.flixcart.com/image/832/832/xif0q/shopsy-kids-apparel-combo/j/z/0/5-6-years-cpby0096-carrydreams-original-imahayr6rbvsf6g5.jpeg?q=70&crop=false",
          imageAlt: "Kids clothing collection with colorful and fun designs.",
        },
        {
          name: "Playwear",
          href: "/",
          imageSrc:
            "https://rukminim2.flixcart.com/image/832/832/xif0q/bodysuit-sleepsuit/w/i/e/0-6-9-months-gobs20-2465-white-mellange-babygo-3-original-imah3ckjwe875ftm.jpeg?q=70&crop=false",
          imageAlt: "Comfortable and durable kids playwear in various sizes.",
        },
      ],
      sections: [
        {
          id: "clothing",
          name: "Clothing",
          items: [
            { name: "T-Shirts", id: "t-shirts" },
            { name: "Shirts", id: "shirt" },
            { name: "Dresses", id: "women_dress" },
            { name: "Jeans", id: "men_jeans" },
            { name: "Shorts", id: "shorts" },
            { name: "Jackets", id: "jackets" },
            { name: "Sweaters", id: "sweaters" },
            { name: "Activewear", id: "activewear" },
          ],
        },
      ],
    },
  ],
  pages: [
    { name: "Company", id: "/" },
    { name: "Stores", id: "/" },
  ],
};
